module.exports = __webpack_public_path__ + "img/Line_logo.35843975.png";